import { render, staticRenderFns } from "./PublichCheck.vue?vue&type=template&id=c1a07d0c&scoped=true"
import script from "./PublichCheck.vue?vue&type=script&lang=js"
export * from "./PublichCheck.vue?vue&type=script&lang=js"
import style0 from "./PublichCheck.vue?vue&type=style&index=0&id=c1a07d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a07d0c",
  null
  
)

export default component.exports